var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sm-reports__main"},[_c(_vm.currentTab,{tag:"components",attrs:{"reqCSV":_vm.reqCSV,"reqPDF":_vm.reqPDF,"isGlobalReport":_vm.currentTab === 'global-report'},on:{"finishCSV":function($event){return _vm.$emit('finishCSV')},"finishPDF":function($event){return _vm.$emit('finishPDF')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }